import http from "../../utils/http-common";
import { useQuery } from "@tanstack/react-query";

export function useDashboard() {
  const getDashboard = async () => {
    const response = await http.get("/dashboard");
    return response.data;
  };
  return useQuery({
    queryKey: ["dashboard"],
    queryFn: getDashboard,
    // refetchInterval: 5000,
  });
}
